import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import i18n from '@/i18n'
import { LessonView } from '@/modules/lessonDetails'
import { courseQueryOptions } from '@/queries/useCourse'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute(
  '/_auth/timetable/$courseId/$groupId/lesson-details'
)({
  validateSearch: z.object({
    lessonId: z.string().catch('')
  }),
  component: LessonView,
  loader: async ({ context, params: { courseId } }) => {
    const course = await context.queryClient.ensureQueryData(
      courseQueryOptions(courseId)
    )
    return course.name
  },
  head: ({ loaderData }) =>
    getMetaWithPageTitle([
      loaderData,
      i18n.t('title.details', { ns: 'lessonDetails' })
    ])
})
